const globalVars = {
    isOmnitureDisable: false,
    removeDirectAcessPagesList: {},
};

export default globalVars;
